import React from 'react';

const IconTo = ({ width = '34.2', height = '12.632', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 34.2 12.632" {...other}>
            <g stroke="currentColor" strokeWidth="1.3">
                <rect height="7.613" rx="0.692" transform="rotate(-135 3.375 5.463)" width="1.384" />

                <rect height="7.613" rx="0.692" transform="rotate(-45 2.75 -.16)" width="1.384" />

                <rect height="7.613" rx="0.692" transform="rotate(-135 9.875 2.771)" width="1.384" />

                <rect height="7.613" rx="0.692" transform="rotate(-45 9.25 -15.853)" width="1.384" />

                <rect height="7.613" rx="0.692" transform="rotate(-135 16.375 .079)" width="1.384" />

                <rect height="7.613" rx="0.692" transform="rotate(-45 15.75 -31.545)" width="1.384" />
            </g>
        </svg>
    );
};
export default React.memo(IconTo);
